module.exports = __webpack_public_path__ + "img/e.24b6a986.png";